const COLORS = {
  mainColor: "#88D47B",
  gray: "#C6C6C6",
  lightgray: "#d9d9d9",
};

export default COLORS;
